<template>
  <div>
    <div class="courseCaseManage div-layout">
      <module-title title="课程案例管理">
        <div class="right">
          <el-button type="primary" size="medium" icon="el-icon-plus" @click="dialogVisible = true">
            添加课程案例管理
          </el-button>
        </div>
      </module-title>
      <el-table v-loading="listLoading" :data="viewData" highlight-current-row fit element-loading-text="Loading" class="list-table">
        <el-table-column type="index" prop="index" width="55" align="center" label="序号" />
        <el-table-column label="主题名称" align="center" prop="subjectName" />
        <el-table-column label="课程阶段" align="center" width="150" prop="courseStageName" />
        <el-table-column label="主题简介" align="center" prop="subjectDesc" />
        <el-table-column label="添加时间" align="center" prop="createDate" />
        <el-table-column label="更新时间" align="center" prop="updateDate" />
        <el-table-column label="排序" align="center" prop="url">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.seq"
              name="specUnit"
              maxlength="9"
              style="width:100px;"
              oninput="value=value.replace(/[^\d]/g,'')"
              @blur="rankHandle(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button type="danger" size="small" @click="handlerDelete(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="pageObj.total" :page.sync="pageObj.pageNum" :limit.sync="pageObj.pageSize" @pagination="pageCurriculumList" @handleSizeChange="handleSizeChange" />
      <el-dialog width="600px" :close-on-click-modal="false" :visible.sync="dialogVisible" title="添加课程案例" @close="dialogClose">
        <el-form ref="handleForm" :rules="rules" size="small" label-width="80px" :model="handleForm">
          <el-form-item label="主题名称" prop="subjectName">
            <el-input v-model="handleForm.subjectName" />
          </el-form-item>
          <el-form-item label="课程阶段" prop="courseStage">
            <el-select v-model="handleForm.courseStage" placeholder="请选择">
              <el-option v-for="(v,i) in courseStage" :key="i" :label="v.name" :value="v.code" />
            </el-select>
          </el-form-item>
          <el-form-item label="主题简介" prop="subjectDesc">
            <el-input v-model="handleForm.subjectDesc" type="textarea" :rows="6" maxlength="500" show-word-limit />
          </el-form-item>
          <el-form-item label="排序" prop="seq">
            <el-input v-model="handleForm.seq" style="width:80px;" maxlength="9" name="seq" @change="inputNum($event,'seq')" @input="inputNum($event,'seq')" />
          </el-form-item>
          <div class="up-box">
            <el-form-item label="图片">
              <!-- <SingImageUpload type="pngAndVideo" @uploadSucess="uploadSucessFn" :size="baseProps" :isDisplay="fileList.length>4?true:false" accept="image/png, image/jpg,video/mp4,video/avi,video/wmv" /> -->
              <div v-if="fileList.length<6">
                <upload-file
                  :props="{serveCode:'train_course_case_attachment',accept:'.png, .jpg, .mp4',type:['image/jpg','image/png','video/mp4']}"
                  @uploadSucess="uploadSucessFn"
                >
                  <el-button size="small" type="primary">
                    点击上传
                  </el-button>
                </upload-file>
              </div>
              <div v-else>
                <el-button :disabled="true" size="small" type="primary">
                  点击上传
                </el-button>
              </div>
              <div style="color:red">
                <p>文件支持PNG、JPG、MP4格式</p>
                <p>建议上传图片尺寸820x462px</p>
              </div>
              <div v-if="fileList.length" class="url-box">
                <div v-for="(item,index) in fileList" :key="index" class="video-box">
                  <i class="el-icon-circle-close" @click="removePic(item,index)" />
                  <el-image v-if="item.suffixName=='.png' || item.suffixName=='.jpg'" style="width:100%;height:100%" :src="item.path" :preview-src-list="[item.path]" />
                  <video v-if="item.suffixName=='.mp4'" :src="item.path" class="avatar" @click.stop="handlePreview('video',item.path)" />
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="dialogClose">
            取消
          </el-button>
          <el-button type="primary" size="medium" :loading="ajaxLoading" @click="handleSubmitForm">
            {{ ajaxLoading ? "Loading" : "保存" }}
          </el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="previewImg.dialogVideoVisible" title="预览" width="1000px" style="text-align:center" @close="closeVideo">
        <video ref="videoRef" :src="previewImg.url" controls autoplay style="max-width:100%" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getCourseCasesPageList, createTrainCourseCases, updateTrainCourseCases, deleteTrainCourseCases, changeCourseCasesSeq, getCourseCasesDetail } from '@/api/officialWebsiteConfig/index';
// import SingImageUpload from '@/components/SingleImageUpload';
import { getDictsType } from '@/api/productOperation/public/FQColumnmanages';
export default {
  // components: { SingImageUpload },
  data() {
    return {
      listLoading: false,
      viewData: [],
      dialogVisible: false,
      value: '',
      ajaxLoading: false,
      url: '',
      baseProps: {
        width: 850,
        heigth: 500
      },
      rules: {
        subjectName: [
          { required: true, message: '主题名称不能为空', trigger: 'change' }
        ],
        subjectDesc: [
          { required: true, message: '主题简介不能为空', trigger: 'change' }
        ],
        courseStage: [
          { required: true, message: '课程阶段不能为空', trigger: 'change' }
        ],
        seq: [
          { required: true, message: '排序不能为空', trigger: 'change' }
        ]
      },
      pageObj: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      handleForm: {
        attachmentList: [],
        id: '',
        seq: '',
        status: 1, // 状态：0.禁用；1.启用；
        subjectDesc: '', // 主题简介
        subjectName: '', // 主题名称
        courseStage: '' // 课程阶段
      },
      previewImg: {
        dialogVideoVisible: false
      },
      terminaltype3: 'train_website_course_stage', // 课程阶段字典
      courseStage: [],
      casesDetail: {},
      handleType: 'add',
      fileList: []
    };
  },
  mounted() {
    this.getType();
    this.getTableList();
  },
  methods: {
    inputNum(value, item) {
      this.handleForm[item] = value.replace(/^\.+|[^\d.]/g, '');
    },
    // 获取类型列表
    getType() {
      getDictsType(this.terminaltype3).then(res => {
        this.courseStage = res.data;
      });
    },
    handleEdit(row) {
      getCourseCasesDetail(row.id).then(res => {
        const { attachmentList, id, seq, status, subjectDesc, subjectName, courseStage } = res.data;
        attachmentList.forEach(e => {
          this.handleForm.attachmentList.push({ attachName: e.attachName, attachUrl: e.attachUrl, subjectId: e.courseCaseId });
          const suffixName = this.getFileExtendingName(e.attachName).toLowerCase();
          this.fileList.push({ attachName: e.attachName, path: e.attachAbsoluteUrl, suffixName: suffixName });
        });
        this.handleForm = {
          attachmentList: this.handleForm.attachmentList,
          id: id,
          seq: seq,
          status: status, // 状态：0.禁用；1.启用；
          subjectDesc: subjectDesc, // 主题简介
          subjectName: subjectName, // 主题名称
          courseStage: courseStage // 课程阶段
        };

        this.handleType = 'edit';
        this.dialogVisible = true;
      });
    },
    getFileExtendingName(filename) { // 获取扩展名
      var reg = /\.[^\.]+$/;
      var matches = reg.exec(filename);
      if (matches) {
        return matches[0];
      }
      return '';
    },
    handleSubmitForm() {
      if (this.handleForm.attachmentList.length <= 0) {
        this.$message.error('请上传图片或视频');
        return;
      }
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.ajaxLoading = true;
          if (this.handleForm.id) {
            updateTrainCourseCases(this.handleForm.id, this.handleForm).then((res) => {
              this.ajaxLoading = false;
              this.$notify.success({ title: 'Success', message: '修改成功', showClose: false, duration: 2000 });
              this.getTableList();
              this.dialogClose();
            }).catch(() => {
              this.ajaxLoading = false;
            });
          } else {
            createTrainCourseCases(this.handleForm).then((res) => {
              this.ajaxLoading = false;
              this.$notify.success({ title: 'Success', message: '添加成功', showClose: false, duration: 2000 });
              this.getTableList();
              this.dialogClose();
            }).catch(() => {
              this.ajaxLoading = false;
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    rankHandle(row) {
      changeCourseCasesSeq(row.id, row.seq).then((res) => {
        this.getTableList();
      });
    },
    handlePreview(type, url) {
      this.previewImg.dialogVideoVisible = true;
      this.previewImg.url = url;
      if (this.$refs.videoRef) {
        this.$refs.videoRef.play();// 暂停
      }
    },
    closeVideo() {
      if (this.$refs.videoRef) {
        this.$refs.videoRef.pause();// 暂停
      }
    },
    uploadSucessFn(fileList) {
      this.fileList.push({
        path: fileList.absolutePath,
        relativePath: fileList.relativePath,
        fileName: fileList.file.name,
        suffixName: this.getFileExtendingName(fileList.file.name).toLowerCase()
      });
      this.handleForm.attachmentList.push({
        attachName: fileList.file.name,
        attachUrl: fileList.relativePath,
        subjectId: ''
      });
    },
    removePic(file, index) {
      this.fileList.splice(index, 1);
      this.handleForm.attachmentList.splice(index, 1);
    },
    handlerDelete(row) {
      this.$confirm(`确定要删除该课程案例么?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        return deleteTrainCourseCases(row.id);
      }).then(res => {
        this.$notify.success({ title: 'Success', message: '删除成功', showClose: false, duration: 2000 });
        this.getTableList();
      }).catch(() => {});
    },
    dialogClose() {
      this.handleForm = this.$options.data().handleForm;
      this.dialogVisible = false;
      this.$refs.handleForm.resetFields();
      this.handleForm.attachmentList = [];
      this.fileList = [];
    },
    // 分页
    pageCurriculumList(obj) {
      this.pageObj.pageNum = obj.page;
      this.getTableList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.pageObj.pageNum = 1;
      this.pageObj.pageSize = obj.limit;
      this.getTableList();
    },
    // 获取列表
    getTableList() {
      this.listLoading = true;
      getCourseCasesPageList({ ...this.searchForm, pageNum: this.pageObj.pageNum, pageSize: this.pageObj.pageSize }).then(res => {
        this.listLoading = false;
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.viewData = [];
          this.pageObj.total = 0;
        } else {
          this.viewData = res.data.list;
          this.pageObj.total = res.data.total;
        }
      }).catch(err => {
        this.listLoading = false;
        console.log(err);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.up-box{
  /deep/.el-form-item__label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }
}
.url-box{
    display: flex;
    margin-top: 10px;
}
.el-icon-circle-close {
  position: absolute;
  cursor: pointer;
  z-index: 5;
  top: 3px;
  right: 3px;
}
.video-box{
    width: 100px;
    height: 60px;
    border: 1px solid #ccc;
    margin-right: 10px;
    position: relative;
    .avatar{
        width: 100%;
        height: 100%;
    }
  }
</style>
